import gql from "graphql-tag";

const SUB_NEW_CLIENT_REGISTRATION_COUNT = gql`
    subscription realtorClientRegistrationCount($division_id:Int){
        realtorClientRegistrationCount(division_id: $division_id)
    }
`;

export default SUB_NEW_CLIENT_REGISTRATION_COUNT;
